import { type CreateOrderV4AsyncArgs } from "~/api/orders/requests";
import { type TillKiosk } from "~/api/tills/types";

/**
 * The group a kiosk customer who hasn't scanned their app orders as: the
 * till's guest group, otherwise the location's only group (self-service skips
 * its selector screen for that one too), otherwise none.
 */
export function getKioskGuestGroupName(
  till: TillKiosk,
  locationGroupNames: string[] | undefined
): string | null {
  if (till.config.guestSelector) return till.config.guestSelector;
  return locationGroupNames?.length === 1 ? locationGroupNames[0] : null;
}

/**
 * Who a kiosk order is priced and placed for: the scanned user, otherwise the
 * guest group, otherwise nobody (the till's own profile).
 */
export function getKioskUserIdentifier(
  till: TillKiosk,
  locationGroupNames: string[] | undefined,
  childId: string | null
): CreateOrderV4AsyncArgs["userIdentifier"] {
  if (childId) return { type: "child-id", value: childId };

  const guestGroupName = getKioskGuestGroupName(till, locationGroupNames);
  return guestGroupName ? { type: "group-name", value: guestGroupName } : null;
}
